module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-collapse-item"]
  }, [_c('div', {
    staticClass: ["dof-collapse-item-content"]
  }, [_c('div', {
    staticClass: ["title"],
    style: {
      'backgroundColor:active': _vm._isColmo ? 'rgba(255,255,255,0.14)' : _vm._isDiablo ? '#1d1f21' : '#fff'
    },
    on: {
      "click": _vm.onCollapseHandler
    }
  }, [_c('div', {
    class: ['title-box', _vm.collapsed_ ? 'bottom-line' : '']
  }, [_vm._t("title"), _c('div', {
    staticClass: ["dof-header-arrow-box"]
  }, [_vm._t("desc"), (_vm._isColmo) ? _c('dof-iconfont', {
    ref: "arrow",
    attrs: {
      "code": '\u4814',
      "size": 48,
      "color": 'rgba(255,255,255,0.8)'
    },
    on: {
      "dofIconFontClicked": _vm.onCollapseHandler
    }
  }) : _c('image', {
    ref: "arrow",
    staticClass: ["dof-header-arrow"],
    attrs: {
      "src": _vm.arrowUp
    }
  })], 2)], 2)])]), _c('div', {
    ref: "slotBody",
    staticClass: ["dof-item-body"]
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-7a9be4d0!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-collapse-item/index.vue
// module id = 645
// module chunks = 0 1